module.exports = __webpack_public_path__ + "img/saudia.fe2bcf97.png";